import { Button, Divider, Input } from 'antd'
import { motion } from 'framer-motion'
import { func, string } from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import Confetti from 'react-confetti'
import { useTranslation } from 'react-i18next'
import { BsLinkedin } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux'
import { handleInitStatus } from '../../../../api/talents.api'
import FinalStepSVG from '../../../../assets/images/finalStep.svg'
import img from '../../../../assets/undraw_maker_launch_crhe.png'
import { setLinkedinUrl } from '../../../../redux/reducers/talentSlice'
import { capitalize } from '../../../../utils/utils'
import { onboardingContext } from '../../Home/OnboardingProvider'
import SectorStep from '../../Home/SectorStep/SectorStep'
import ContractType from '../../Profile/ProfileForm/Fields/ContractType/ContractType'
import JobDomain from '../../Profile/ProfileForm/Fields/JobDomain/JobDomain'
import Location from '../../Profile/ProfileForm/Fields/Location/Location'
import Remote from '../../Profile/ProfileForm/Fields/Remote/Remote'
import SalaryRange from '../../Profile/ProfileForm/Fields/SalaryRange/SalaryRange'
import SchoolLevel from '../../Profile/ProfileForm/Fields/SchoolLevel/SchoolLevel'
import SearchStatus from '../../Profile/ProfileForm/Fields/SearchStatus/SearchStatus'

const variants = {
  out: { opacity: 0, x: '15%' },
  enter: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 300 },
  duration: 0.22,
}

const propTypes = {
  handleNextStep: func.isRequired,
  companyName: string,
  firstname: string.isRequired,
}

const defaultProps = {
  companyName: '',
}

export const WelcomeStep = ({
  handleNextStep,
  companyName = '',
  firstname,
}) => {
  const { isLoading } = useContext(onboardingContext)

  const { t } = useTranslation(['common', 'talentArea'], { useSuspense: false })
  return (
    <>
      <div style={{ marginTop: '1.3em' }}>
        <div
          className="flex column align-center justify-center"
          style={{ gap: '2em' }}
        >
          <h1 className="block text-center">
            {t('common:welcome')} {capitalize(firstname)}
          </h1>
          {/* TODO: may be here we need to change size from device's height */}
          <img src={img} alt="illustration" height={150} />
          <div style={{ marginTop: 10 }}>
            <p className="text-center">
              {t('talentArea:onboarding.stepOne.content', {
                name: companyName,
              })}
            </p>
          </div>
        </div>
        <div
          className="flex align-center"
          style={{ flexDirection: 'column', marginTop: 20 }}
        >
          <div
            className="flex justify-center"
            style={{
              paddingBottom: 5,
              fontSize: 13,
              opacity: 0.5,
              gap: 5,
            }}
          >
            <span>{t('common:cguLink.label')}</span>
            <a
              data-cy="cgu-link"
              href="https://www.hollo.io/mentions-legales"
              style={{
                cursor: 'pointer',
                color: '#254397',
                textDecoration: 'underline',
              }}
            >
              {t('common:termsAcronym')}
            </a>
          </div>
          <Button
            data-cy="next-step-btn"
            className="basic-btn"
            onClick={handleNextStep}
            loading={isLoading}
          >
            {t('common:next')}
          </Button>
        </div>
      </div>
    </>
  )
}
WelcomeStep.propTypes = propTypes
WelcomeStep.defaultProps = defaultProps

export const FirstStep = () => {
  const { candidateIds, firstname } = useSelector((state) => state.talent)
  const { t } = useTranslation(['common'], { useSuspense: false })
  const dispatch = useDispatch()
  const { linkedinUrl } = useSelector((state) => state.talent)
  const [linkedinInput, setLinkedinInput] = useState('')
  const [linkedinTo, setLinkedinTo] = useState('')

  useEffect(() => {
    handleInitStatus(candidateIds, 'started')
  }, [candidateIds])
  return (
    <motion.div
      className="container-step flex align-center "
      initial="out"
      animate="enter"
      exit="exit"
      enter={{ opacity: 0 }}
      variants={variants}
      transition={{ duration: variants.duration }}
      style={{
        paddingTop: '5vh',
      }}
    >
      {/* <h1>1/4 - {t('common:general')}</h1> */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <h2 style={{ marginBottom: '2rem' }}>
          {t('common:welcome')} {capitalize(firstname)} !
        </h2>
        <ContractType />
        <Divider style={{ margin: '1.2rem 0' }} />
        <SchoolLevel />
        <Divider style={{ margin: '1.2rem 0' }} />
        <SalaryRange />
        <Divider style={{ margin: '1.2rem 0' }} />
        <div>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="linkedin" className="field-label">
            Linkedin url
            <Input
              value={linkedinInput}
              onChange={(e) => {
                setLinkedinInput(e.target.value)
                clearTimeout(linkedinTo)
                setLinkedinTo(
                  setTimeout(() => {
                    dispatch(setLinkedinUrl(e.target.value))
                  }, 900),
                )
              }}
              name="linkedin"
              prefix={<BsLinkedin color="grey" />}
              placeholder="Your Linkedin url"
            />
          </label>
        </div>
      </div>
    </motion.div>
  )
}

export const SecondStep = () => {
  const { t } = useTranslation(['common', 'talentArea'], { useSuspense: false })
  return (
    <motion.div
      className="container-step flex column "
      initial="out"
      animate="enter"
      exit="exit"
      variants={variants}
      enter={{ opacity: 0 }}
      transition={{ duration: variants.duration }}
      style={{
        paddingTop: '5vh',
      }}
    >
      <SearchStatus required={false} />
      <Divider style={{ margin: '2.3rem 0' }} />
      <Remote />
      <Divider style={{ margin: '2.3rem 0' }} />
      <Location />
    </motion.div>
  )
}

export const ThirdStep = () => {
  const { t } = useTranslation(['common', 'talentArea'], { useSuspense: false })

  return (
    <motion.div
      className="container-step flex align-center"
      initial="out"
      animate="enter"
      variants={variants}
      enter={{ opacity: 0 }}
      transition={{ duration: variants.duration }}
      style={{
        paddingTop: '5vh',
      }}
    >
      {/* <h1 className="text-center">
        3/4 - {t('talentArea:onboarding.stepThree.title')}
      </h1> */}
      <div
        className="container-step flex  align-center"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 44,
        }}
      >
        <SectorStep />
      </div>
    </motion.div>
  )
}

export const FourthStep = () => {
  const { t } = useTranslation(['common', 'talentArea'], { useSuspense: false })

  return (
    <motion.div
      className="container-step flex align-center"
      initial="out"
      animate="enter"
      variants={variants}
      enter={{ opacity: 0 }}
      transition={{ duration: variants.duration }}
      style={{
        paddingTop: '5vh',
      }}
    >
      {/* <h1 className="text-center">
        3/4 - {t('talentArea:onboarding.stepThree.title')}
      </h1> */}
      <div
        className="container-step flex column"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 44,
        }}
      >
        <JobDomain />
      </div>
    </motion.div>
  )
}

export const FinalStep = () => {
  const { t } = useTranslation(['common', 'talentArea'], { useSuspense: false })

  return (
    <motion.div
      className="flex column container-step"
      initial="out"
      animate="enter"
      exit={{ opacity: 0 }}
      enter={{ opacity: 0 }}
      variants={variants}
      transition={{ duration: variants.duration }}
    >
      {/* <h1 className="text-center block">
        4/4 - {t('talentArea:onboarding.stepFour.title')}
      </h1> */}
      <div
        className="letsGO"
        style={{
          height: '100vh',
          maxWidth: 600,
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          margin: '-14em auto 0px auto',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        <h3 style={{ textAlign: 'center', paddingTop: '4rem' }}>
          Votre profil candidat est prêt !
        </h3>
        <p>
          Vous pouvez maintenant découvrir d’autres annonces adaptées à votre
          profil.
        </p>
        <img src={FinalStepSVG} alt="success" height={200} />
      </div>
      <Confetti
        recycle
        style={{
          zIndex: 9999,
        }}
      />
    </motion.div>
  )
}
